var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checklist-files"},[_c('r-button',{on:{"click":function($event){return _vm.clickHandler('select-photo')}}},[_vm._v(" Выбрать фотографии ")]),_c('div',{staticClass:"checklist-files__content"},[_c('checklistFilesList',{attrs:{"attr-id":_vm.attrId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }